import Vue from "vue";
import firebase from 'firebase/compat/app'

export default {
};

export const auth = {
    install(Vue) {
        Vue.prototype.$auth = {
            login: async function (email, password) {
                await firebase
                    .auth()
                    .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
                    .then(async () => {
                        await firebase
                            .auth()
                            .signInWithEmailAndPassword(email, password)
                            .then(() => {
                            })
                            .catch((error) => {
                                throw (error);
                            });
                    })
                    .catch((error) => {
                        throw (error);
                    });
            },
            logout: async function () {
                await firebase.auth().signOut();
            },
            currentUser: function () {
                return firebase.auth().currentUser;
            },
            reauthenticate: async function (password) {
                let user = firebase.auth().currentUser;
                let credential =
                    firebase.auth.EmailAuthProvider.credential(
                        user.email,
                        password
                    );
                await user.reauthenticateWithCredential(credential);
            },
            updatePassword: async function (newPassword) {
                let user = firebase.auth().currentUser;
                await user
                    .updatePassword(newPassword)
                    .catch((e) => {
                        throw (e);
                    });
            },
        }
    }
};

Vue.use(auth);